module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_landscape_bg-81af5b2020725e15533655135b7e63e2.png";